module.exports = __webpack_public_path__ + "static/avatar_denis_kostyakov@2x-2110872c26ba1849be7d0e539234a4aa.jpg";